import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, effect, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TradeInRequest } from '@app/sales/models/trade-in-product.model';
import {
  CreateTradeInVoucherAction,
  QuoteResetAction,
  SetSelectedTradeInStepIndexAction,
} from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.actions';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { select, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { OSAffectedControlType } from '../../models/trade-in-enums';
import { TradeInHelperService } from '../../services/trade-in-helper.service';
import { ControlInquiryComponent } from '../control-inquiry/control-inquiry.component';
import { InformationDisclosureComponent } from '../information-disclosure/information-disclosure.component';
import { TradeInConfirmationComponent } from './trade-in-confirmation/trade-in-confirmation.component';
import { TradeInMobilePhoneDetailsComponent } from './trade-in-mobile-phone-details/trade-in-mobile-phone-details.component';
import { TradeInStepperComponent } from './trade-in-stepper/trade-in-stepper.component';

@Component({
  selector: 'app-trade-in-dialog',
  templateUrl: './trade-in-dialog.component.html',
  styleUrl: './trade-in-dialog.component.scss',
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    TradeInMobilePhoneDetailsComponent,
    ControlInquiryComponent,
    SpinnerComponent,
    TradeInStepperComponent,
    TradeInConfirmationComponent,
    InformationDisclosureComponent,
  ],
})
export class TradeInDialogComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private tradeInHelperService = inject(TradeInHelperService);

  IconNames = IconNames;

  isCalculatingTradeInValue = select(TradeInSelectors.isCalculatingTradeInValue);
  tradeInVoucher = select(TradeInSelectors.tradeInVoucher);
  selectedStep = select(TradeInSelectors.selectedStep);
  quote = select(TradeInSelectors.quote);

  private previousTradeInRequest: TradeInRequest;

  showConfirmationStep = false;
  inquiredControl: OSAffectedControlType | string;

  subscriptions$: Subscription[] = [];

  constructor() {
    effect(() => {
      if (!Number.isNaN(this.selectedStep())) this.inquiredControl = '';
    });
  }

  ngOnInit(): void {
    if (this.tradeInVoucher()?.approved) this.store.dispatch(new SetSelectedTradeInStepIndexAction(1));
  }

  onConfirmationBackClicked(): void {
    this.store.dispatch(new QuoteResetAction());
    this.showConfirmationStep = false;
  }

  createTradeInVoucher() {
    const request = this.tradeInHelperService.createTradeInVoucherRequest();

    if (JSON.stringify(this.previousTradeInRequest) !== JSON.stringify(request)) {
      this.store.dispatch(new CreateTradeInVoucherAction(request));
      this.previousTradeInRequest = request;
    }

    this.showConfirmationStep = true;
  }

  ngOnDestroy(): void {
    this.subscriptions$.forEach(subscription => subscription.unsubscribe());
  }
}
